/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPolicyFeaturesQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetPolicyFeaturesQuery = { __typename?: 'Query', surveyPolicyFeatures: { __typename?: 'PolicyFeatures', id: string, ownOccupationPolicy: boolean, residualDisabilityPolicy: boolean, noncancellable: boolean } };


export const GetPolicyFeaturesDocument = gql`
    query GetPolicyFeatures {
  surveyPolicyFeatures {
    id
    ownOccupationPolicy
    residualDisabilityPolicy
    noncancellable
  }
}
    `;
export function useGetPolicyFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>(GetPolicyFeaturesDocument, options);
      }
export function useGetPolicyFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>(GetPolicyFeaturesDocument, options);
        }
export function useGetPolicyFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>(GetPolicyFeaturesDocument, options);
        }
export type GetPolicyFeaturesQueryHookResult = ReturnType<typeof useGetPolicyFeaturesQuery>;
export type GetPolicyFeaturesLazyQueryHookResult = ReturnType<typeof useGetPolicyFeaturesLazyQuery>;
export type GetPolicyFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetPolicyFeaturesSuspenseQuery>;
export type GetPolicyFeaturesQueryResult = Apollo.QueryResult<GetPolicyFeaturesQuery, GetPolicyFeaturesQueryVariables>;